module.exports = __webpack_public_path__ + "img/under-maintenance-dark.8a8dd8f0.svg";